module.exports = __webpack_public_path__ + "img/worksbot_img20021101.a958dbd9.jpg";